import { useContext, useEffect, useRef } from "react";
import { DialogRegionContext } from "./announcer-context";

/**
 * Batch 26 (ruling of 20 Oct): the polite live region inside a modal `<dialog>`, where the app's announcer (`useAnnounce`) speaks
 * while that dialog is the top-most one open. Rendered empty and present for as long as the dialog is open, so the browser knows
 * the region before any text lands in it; the announcer fills it, React never does. One per dialog, never used directly.
 */
export function DialogLiveRegion() {
  const register = useContext(DialogRegionContext);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const region = ref.current;
    return region ? register(region) : undefined;
  }, [register]);
  // aria-live without role="status": a dialog's own visible status lines stay the only `status` in it (screens and tests look them up).
  return <div ref={ref} aria-live="polite" aria-atomic="true" className="vh" data-testid="dialog-announcer" />;
}
